<template>
  <div
      class="inputComponent"
      :style="{padding: props.padding}"
      :class="{
      'error-border': props.required && isInvalid,
      'valid-border': props.required && isValid,
    }"
  >
    <input
        type="number"
        class="input"
        :style="{ fontSize: props.fontSize }"
        v-model="inputRes"
        @input="onInput"
    />

  </div>
</template>

<script setup>
import { defineEmits, ref, watch, defineProps, onMounted, defineExpose, computed } from "vue";

const inputRes = ref('');

const props = defineProps({
  defaultValue: {
    default: ''
  },
  selectedMetal: {
    default: 'silver'
  },
  fontSize: {
    default: "14px"
  },
  padding: {
    default: '10px'
  },
  required: {
    type: Boolean,
    default: false,
  }
});

const onInput = (e) => {
  const value = Number(e.target.value);
  if (value < 0) {
    inputRes.value = '0';
  }
};

onMounted(() => {
  if (props.defaultValue !== '') {
    inputRes.value = props.defaultValue;
  }
});

const resetValue = (value = 0) => {
  inputRes.value = value;
};

const emit = defineEmits(['update:modelValue']);

const isInvalid = computed(() => {
  return props.required && (inputRes.value === '' || Number(inputRes.value) === 0);
});

const isValid = computed(() => {
  return props.required && inputRes.value !== '' && Number(inputRes.value) > 0;
});


watch(inputRes, (newValue) => {
  emit('update:modelValue', newValue);
});

watch(() => props.selectedMetal, () => {
  inputRes.value = '';
});

defineExpose({
  resetValue
});
</script>

<style scoped>
.inputComponent {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(37, 37, 37, 0.75);
  border-radius: 25px;
}

.input {
  border: 0px;
  width: 50%;
  color: white;
  outline: none;
  background: transparent;
  text-align: center;
}

.error-border {
  border: 2px solid red;
}

.valid-border {
  border: 2px solid #5FF900;
}
</style>
